import ALERT_TYPES from "./alert/users.alert.types";
var Users = /** @class */ (function () {
    function Users($stateParams, UsersDetails, PermPermissionStore, ModalService, UsersAlertService, NotificationService, Router) {
        this.params = $stateParams;
        this.getFullName = UsersDetails.getFullName;
        this.isActive = UsersDetails.isActive;
        this.PermPermissionStore = PermPermissionStore;
        this.ModalService = ModalService;
        this.userNameTruncate = 25;
        this.UsersAlertService = UsersAlertService;
        this.notificationService = NotificationService;
        this.router = Router;
    }
    Users.prototype.$onInit = function () {
        this.currentUser = this.getUsersForCurrentState()[0];
    };
    // destroys closable notification of 'failed StripePayment' which also redirects here
    Users.prototype.$onDestroy = function () {
        this.notificationService.dismiss();
    };
    Users.prototype.toState = function (user) {
        this.UsersAlertService.deleteSuccessAlerts();
        if (user.state === 'PENDING') {
            this.router.navigateByUrl("/users/" + this.state + "/" + user.uniqueId + "/invite");
        }
        else {
            this.router.navigateByUrl("/users/" + this.state + "/" + user.uniqueId + "/details");
        }
    };
    Users.prototype.getState = function () {
        return this.state === 'all' || !this.state ? undefined : this.state.toUpperCase();
    };
    Users.prototype.isPending = function (user) {
        return user.state === 'PENDING';
    };
    Users.prototype.setCurrentUser = function (user) {
        this.currentUser = user ? user : this.getUsersForCurrentState()[0];
    };
    Users.prototype.responsiveMenuShow = function () {
        this.showMenu = !this.showMenu;
    };
    Users.prototype.onChangeFind = function (find) {
        this.find = find;
    };
    Users.prototype.isSetUserView = function () {
        return this.userIndex;
    };
    Users.prototype.isPendingAndActive = function (user) {
        return !this.isPending(user) && !this.isActive(user);
    };
    Users.prototype.listContainsUsers = function () {
        return this.getUsersForCurrentState().length > 0;
    };
    Users.prototype.listContainsMoreThanOneUser = function () {
        return this.getUsersForCurrentState().length > 1;
    };
    Users.prototype.getUsersForCurrentState = function () {
        var _this = this;
        return this.userList.filter(function (user) { return user.state === (_this.getState() ? _this.getState() : user.state); });
    };
    Users.prototype.gotoAllUsers = function () {
        this.router.navigateByUrl("/users/all/0/details");
    };
    Users.prototype.showLimitUsersAlert = function () {
        this.UsersAlertService.prependAlert(ALERT_TYPES.noFreeSlots);
    };
    Users.prototype.getUsersList = function () {
        return this.userList;
    };
    Object.defineProperty(Users.prototype, "validForm", {
        get: function () {
            return this.invitation.email && this.invitation.roleId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Users.prototype, "changedPlan", {
        get: function () {
            return this.params.changedPlan;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Users.prototype, "newInvitation", {
        get: function () {
            return this.params.newInvitation;
        },
        enumerable: true,
        configurable: true
    });
    Users.prototype.isCurrentUser = function (currentUserIndex) {
        return currentUserIndex === parseInt(this.userIndex, 10);
    };
    Users.$inject = ['$stateParams', 'UsersDetails', 'PermPermissionStore', 'ModalService', 'UsersAlertService', 'NotificationService', 'Router'];
    return Users;
}());
export default {
    controller: Users,
    template: require('./users.html'),
    bindings: { userList: '<', userStats: '<', state: '<', userIndex: '<' }
};
